import {AppUrls} from 'shared/config/model/urls';
import {Pages} from 'shared/config/model/pages';

import React from 'react';
import {i18n} from '@lingui/core';
import {t} from '@lingui/core/macro';

import Delete from 'shared/ui/icons/General/Delete';
import {ExceededModal} from 'entities/user';
import {MonitorsScreen} from 'entities/monitor';
import usePortMonitors from 'features/port/model/usePortMonitors';
import {getPortBatchModalHeader} from 'features/port/lib/portBatchHelper';

import CreatePortMonitorButton from '../CreatePortMonitorButton/CreatePortMonitorButton';
import PortMonitorRow from '../PortMonitorRow/PortMonitorRow';
import PortMonitorFiltersFormHandler from '../PortMonitorsFilters/PortMonitorFiltersFormHandler';
import PortMonitorsExportModal from '../PortMonitorsExport/PortMonitorsExportModal';
import PortMonitorBatchOperationsForm from '../PortMonitorForm/PortMonitorBatchOperationsForm';
import PortMonitorModal from '../PortMonitorModal';

const PortMonitors: React.FC = () => {
    const {
        user,
        activeCount,
        sort,
        pagination,
        isLoading,
        isFetching,
        refetch,
        list,
        handleCreate,
        isCreateOpen,
        isExceededOpen,
        closeCreate,
    } = usePortMonitors();

    return (
        <MonitorsScreen
            documentTitle={t`Мониторинг портов | Overseer`}
            title={i18n._(Pages.PORT_MONITORS)}
            count={activeCount ?? 0}
            maxCount={user?.tariff?.port_monitor_max_count_limit}
            backUrl={AppUrls.HOME}
            isFetching={isFetching}
            refetch={refetch}
            FiltersFormHandler={PortMonitorFiltersFormHandler}
            renderExportModal={(state) => <PortMonitorsExportModal {...state}/>}
            list={list}
            extraMassActions={[
                {
                    value: 'remove-by-target',
                    label: t`удаление по списку`,
                    icon: <Delete/>,
                    title: t`Удалить по списку`,
                    ignoreSelection: true,
                },
            ]}
            getBatchHeader={getPortBatchModalHeader}
            renderBatchForm={(props) => <PortMonitorBatchOperationsForm {...props}/>}
            createButton={<CreatePortMonitorButton onClick={handleCreate} disabled={list.hasSelectedItems}/>}
            createText={t`Добавить порт`}
            onCreate={handleCreate}
            columns={[
                {label: t`Название`, sort: 'name'},
                {label: t`Состояние`},
                {label: t`Желаемое состояние`},
                {label: t`Интервал`, sort: 'checkInterval'},
                {label: t`Последняя проверка`, sort: 'lastCheck'},
                {label: t`Статус`, sort: 'status'},
                {label: ''},
            ]}
            items={pagination?.items}
            rowFactory={(item) =>
                <PortMonitorRow
                    key={item.uuid}
                    item={item}
                    user={user}
                    hasSelectedItems={list.hasSelectedItems}
                    isMassOperationsMode={list.isMassOperationsMode}
                />
            }
            isLoading={isLoading}
            pagination={pagination}
            sort={sort}
        >
            <PortMonitorModal
                open={isCreateOpen}
                handleClose={closeCreate}
            />
            <ExceededModal
                isOpen={isExceededOpen}
                handleClose={closeCreate}
                type="port_monitors"
            />
        </MonitorsScreen>
    );
};

export default PortMonitors;
